function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from '../layout.scss';

var AVIFlexRow = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AVIFlexRow, _Component);

  function AVIFlexRow() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = AVIFlexRow.prototype;

  _proto.render = function render() {
    var children = this.props.children;
    return /*#__PURE__*/React.createElement("div", {
      className: 'avi-flex-row flex-row'
    }, children);
  };

  return AVIFlexRow;
}(Component);

export { AVIFlexRow as default };
AVIFlexRow.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};